<template>
    <div id="whatsapp-import-status-card">
        <BucketSpinner class-name="spinner" />
        <div class="items">
            <div class="item">
                <i class="material-icons text-success">check_circle </i>
                {{ state.imported }} {{ $t("whatsapp.contactsImported") }}
            </div>
            <div class="item">
                <i class="material-icons text-danger">cancel </i>
                {{ state.failed }} {{ $t("whatsapp.contactsFailed") }}
            </div>
            <div class="item">
                <i class="material-icons text-info spin">loop </i>
                {{ state.percent }}% {{ $t("whatsapp.percentCompleted") }}
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import BucketSpinner from "../../../Reports/common/spinners/BucketSpinner.vue";

export default Vue.extend({
    name: "WhatsappImportStatusViewer",
    components: { BucketSpinner },
    props: {
        state: {
            type: Object,
            default: () => {
                return {
                    status: "processing",
                    imported: 0,
                    failed: 0,
                    total: 0,
                    percent: 0,
                };
            },
        },
    },
});
</script>

<style scoped lang="scss">
#whatsapp-import-status-card {
    position: fixed;
    bottom: 11px;
    right: 7px;
    padding: 20px;
    color: #fff;
    background-color: #333;
    min-width: 300px;
    z-index: 9999999;
    height: 100px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    align-content: center;
    gap: 5px;

    svg.spinner {
        background-color: #333 !important;
        width: 40px !important;
        height: 40px !important;
        margin: 0 !important;
    }

    .items {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .item {
            display: flex;
            gap: 5px;
            align-items: center;

            .material-icons {
                font-size: 14px;
            }
        }
    }
}
</style>
